export default __webpack_public_path__ + "static/media/fgv-logo.0c751971.png";